import { useEffect, useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { IUseGameList, TSetLoadingFunction } from '../_type';

export default function useGameList(props: IUseGameList) {
  const {
    frameType,
    searchValue,
    setInputValue,
    otherParams,
    getData,
    visible
  } = props || {};

  const [gameList, setGameList] = useState<Array<any>>([]);
  const [filterGames, setFilterGames] = useState<Array<any>>([]);
  const [allLoading, setAllLoading] = useState(false);
  const currentGame = useSelector((state: any) => state?.dashboard?.currentGame, shallowEqual);
  const [error, setError] = useState(false);

  const fetchGameList = async (setLoadingFun: TSetLoadingFunction) => {
    if (getData) {
      getData(setLoadingFun, setGameList, setError);
    }
  };

  useEffect(() => {
    if (!visible) {
      setInputValue('');
    }
  }, [visible]);

  useEffect(() => {
    fetchGameList(setAllLoading);
  }, [currentGame?.game_code, frameType, otherParams]);

  /**
   * 根据搜索值过滤游戏列表
   *
   * @param searchValue 搜索值
   */
  const onDataSearch = (searchValue: string) => {
    if (searchValue) {
      const filteredGames = gameList?.filter((item) => {
        return item?.studio?.toLowerCase().includes(searchValue?.toLowerCase()) || item?.isTitleRow;
      });

      const group1 = filteredGames?.filter((item) => item?.groupIndex === 1);
      const group2 = filteredGames?.filter((item) => item?.groupIndex === 2);
      const group3 = group1.length > 1 ? group1 : []; // 包含标题还存在其他数据时，保留标题行
      const group4 = group2.length > 1 ? group2 : []; // 包含标题还存在其他数据时，保留标题行

      setFilterGames([...group3, ...group4]);
    }
  };

  useEffect(() => {
    onDataSearch(searchValue);
  }, [searchValue, gameList]);

  const renderGameList = useMemo(() => {
    let list = filterGames;
    if (!searchValue) {
      list = gameList;
    }
    return list || [];
  }, [filterGames, searchValue, gameList]);

  return {
    allLoading,
    renderGameList,
    error,
    onDataSearch,
    gameList
  };
}
